import React, { useState, useEffect, useCallback } from 'react';
import Table from '../components/table/table';
import SubNav from '../components/subNav/subNav';
import MembersData from '../data/members.json';
const { membersData } = { ...MembersData }
import DisplayModal from '../modals/displayModal/displayModal';
import { createMemberData, updateMemberData, fetchMemberData, deleteMemberData, fetchUserGlobalSearchData, fetchUserDropdownOptionList, sendNewUserMail } from '../api/membersApi';
import Loader from '../components/loader/loader';
import { exportToExcel } from '../functions/exportToExcel';
import debouce from 'lodash/debounce';
import handle_toast  from '../genericFunctions/toast_Handler';

const Member = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [dataFetched, setDataFlag] = useState(false);
  const [memberData, setMemberData] = useState([])
  const [isLoading, setIsLoading] = useState(true);
  const accessData = sessionStorage.getItem('accessData') ? JSON.parse(sessionStorage.getItem('accessData'))['User Management'] : {};


  // debounce call
  const debouncedCall = useCallback(
    debouce(()=> {
      fetchMembers();
    }, 500), //Adjusting the delay
    []
  );

  const toggleModal = () => {
    setModalVisible(!modalVisible);
  }

  useEffect(() => {
    if (!dataFetched) debouncedCall();
    
    //Clean up the debounce on component unmount
    return () => {
      debouncedCall.cancel();
    };
  }, [dataFetched, debouncedCall]);

  const fetchMembers = async () => {
    try {
      const resp = await fetchMemberData();
      setDataFlag(true)
      setIsLoading(false)
      const formattedData = formatData(resp?.data?.data);
      setMemberData(formattedData)
      handle_toast({message: 'Members data fetched', status: 'success'})
      if (modalVisible) toggleModal();
    }
    catch (error) {
      setIsLoading(false)
      setDataFlag(true);
      handle_toast(error)
    }
  }

  const fetchUserDropdownOptionListData = async () => {
    try {
      const dropDownData = sessionStorage.getItem('dropDownData') ? JSON.parse(sessionStorage.getItem('dropDownData')) : {};
      const resp = await fetchUserDropdownOptionList();
      const userFormat = [];
      resp?.data?.membersList?.map((obj) => {
        userFormat.push({name: `${obj.name} - ${obj.email} (${obj.sesaId})`, id: obj.id, sesaId: obj.sesaId, email: obj.email, username: obj.name, checked: false}) 
      })
      dropDownData.Users = userFormat;
      handle_toast({message: 'Data Fetched', status: 'success'})
      sessionStorage.setItem('dropDownData', JSON.stringify(dropDownData));
    }
    catch (error) {
      handle_toast(error)
    }
  }

  const formatData = (data) => {
    const formattedData = data.map((user) => {
      const teamsMember = [];
      for(let i=0; i<user.Teams.length; i++){
        teamsMember.push(user.Teams[i].name)
      }
      return {
        ...user,
        teamsMember: teamsMember,
        teamsMemberCount: user.Teams.length
      };
    });

    return formattedData;
  };

  const fetchGlobalSearch = async (query) => {
    try {
      const resp = await fetchUserGlobalSearchData(query);
      setIsLoading(false);
      setDataFlag(true)
      const formattedData = formatData(resp?.data?.globalSearchData);
      setMemberData(formattedData);
      handle_toast({message: 'Filtered members data fetched', status: 'success'})
    }
    catch (error) {
      setIsLoading(false)
      setDataFlag(true);
      handle_toast(error)
    }
  }

  const handleSave = async (formData) => {
    setIsLoading(true)
    try {
      formData.status = 'Active';
      formData.isAdmin = false;
      const resp = await createMemberData(formData)
      if (resp) {
        handle_toast({message: 'New member added', status: 'success'})
        await fetchMembers();
        await fetchUserDropdownOptionListData();
        const mailresp = await sendNewUserMail(resp?.data?.data)
        if(mailresp) handle_toast({message: 'Email sent successfully to User', status: 'success'})
      }
    }
    catch (error) {
      setIsLoading(false)
      handle_toast(error)
    }
  }

  const handleEdit = async (formData) => {
    setIsLoading(true)
    try {
      formData.status = 'Active';
      const resp = await updateMemberData(formData)
      if (resp?.status == 200) {
        handle_toast({message: `Member deleted: ${resp?.data?.deletedUser?.name}`, status: 'success'})
        fetchMembers();
        fetchUserDropdownOptionListData();
      }
    }
    catch (error) {
      setIsLoading(false)
      handle_toast(error)
    }
  }

  const handleDelete = async (formData) => {
    setIsLoading(true)
    try {
      const resp = await deleteMemberData(formData)
      if (resp?.status == 200) {
        handle_toast({message: `Member deleted: ${resp?.data?.deletedUser?.name}`, status: 'success'})
        fetchMembers();
        fetchUserDropdownOptionListData();
      }
    }
    catch (error) {
      setIsLoading(false)
      handle_toast(error)
    }
  }

  const excelExport = () => {
    exportToExcel(memberData, membersData.membersHeaders, 'Member')
  }

  return (
    <>
      <div className='componentContainer'>
        {isLoading && <Loader />}
        {!isLoading && <SubNav data={membersData.membersSubNav} access={accessData} handleModalClick={toggleModal} sendReset={fetchMembers} excelExport={excelExport} handleDDSearch={fetchGlobalSearch}></SubNav>}
        <se-container>
          <se-divider option='vertical'></se-divider>
          <div className='tableContainer'>
            {
              <Table access={accessData} columns={membersData.membersHeaders} body={memberData} modalData={membersData.membersModalData} onSave={handleEdit} onDelete={handleDelete}  page='members'/>
            }
          </div>
        </se-container>
        {modalVisible && <DisplayModal toggleModal={toggleModal} data={membersData.membersModalData} source="create" onSave={handleSave} page="member"/>}
      </div>
    </>
  );
};
export default Member;

